export default "__VITE_ASSET__BWFVfvex__"